// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__ZaIkh","text":"styles_text__1G_TD","value":"styles_value__MLtc-"};